import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { restoreSession } from '../../store/actions/authActions';

export default function AuthBootstrap() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreSession());
  }, [dispatch]);

  return null;
}
